import { FC } from 'react';
import useSWRMutation from 'swr/mutation';
import { BordOneToneIcon, Loading } from 'components/NudosComponents';
import { createPdfToolInformation } from 'services/toolsModule';
import { SWR_KEYS } from 'constants/constants';
import { displayErrorNotification, displaySuccessNotification } from 'utils/displayNudosStandardNotifications';
import './DownloadToolInformation.scss';

/**
 * Componente que muestra un enlace para descargar la información de la herramienta en PDF
 * @param productId - ID del producto
 * @param disabled - Si el botón está deshabilitado
 */
const DownloadToolInformation: FC<DownloadToolInformationProps> = ({ productId, disabled }) => {

  const { trigger: createPdfTrigger, isMutating: isLoading } = useSWRMutation(
    SWR_KEYS.createPdfToolInformation,
    async (
      _,
      {
        arg
      }: {
        arg: string;
      }
    ) => {
      return await createPdfToolInformation(arg);
    },
    {
      onSuccess: url => {
        if (url) {
          const newWindow = window.open(url, '_blank');
          if (newWindow) {
            displaySuccessNotification({
              customJSXMessage: <>PDF generado exitosamente</>
            });
          } else {
            displayErrorNotification({
              customJSXMessage: <>No se pudo abrir la ventana. Verifique que los pop-ups estén permitidos</>
            });
          }
        }
      }
    }
  );

  const isDisabled = disabled || isLoading;

  const handleDownload = () => {
    if (disabled || !productId || isLoading) return;
    createPdfTrigger(productId.toString());
  };

  return (
    <div className={`downloadToolInformation ${isDisabled ? 'disabled' : ''}`} onClick={handleDownload}>
      {isLoading ? (
        <Loading style={{ margin: 0 }} />
      ) : (
        <BordOneToneIcon variant="download" customWidth="20px" stroke="#0066FF" />
      )}
      <span className="downloadText">Descargar información de la herramienta</span>
    </div>
  );
};

interface DownloadToolInformationProps {
  productId?: number;
  disabled?: boolean;
}

export default DownloadToolInformation;
